import * as styles from "./Question.module.css";
import { HiOutlineSparkles } from "react-icons/hi2";
import { VscSparkleFilled } from "react-icons/vsc";


export default function Question({ question, onClick }) {
    

    return (
        <div className={styles.container}>
            <div className={styles.icon}>
                <VscSparkleFilled />
            </div>
            <div className={styles.question} onClick={onClick}>
                {question}
            </div>
        </div>
    );
}